import React from "react";
import { ReferenceInput, required, SelectInput } from "react-admin";
import { useField } from "react-final-form";
import { SchoolIdSelected } from "utils/tools";

const CcaAcademicYearInput = ({ parentCallback }: any) => {
  const schoolId = Number(SchoolIdSelected());
  const date = useField("ccaDate");

  return (
    <ReferenceInput
      label="Cca Academic Year"
      source="ccaAcademicYearId"
      reference="ccaAcademicYears"
      filter={{ SchoolId: schoolId }}
      onChange={({ target }) => {
        parentCallback && parentCallback(target.value);
        date.input.onChange("");
      }}
      validate={required()}
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
  );
};

export default CcaAcademicYearInput;
